import { render, staticRenderFns } from "./video-course.vue?vue&type=template&id=1bf01342&scoped=true&"
import script from "./video-course.vue?vue&type=script&lang=js&"
export * from "./video-course.vue?vue&type=script&lang=js&"
import style0 from "./video-course.scss?vue&type=style&index=0&id=1bf01342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf01342",
  null
  
)

export default component.exports